
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesPromoGrid extends Serenity.EntityGrid<ECommSalesPromoRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesPromo'; }
        protected getDialogType() { return ECommSalesPromoDialog; }
        protected getIdProperty() { return ECommSalesPromoRow.idProperty; }
        protected getInsertPermission() { return ECommSalesPromoRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesPromoRow.localTextPrefix; }
        protected getService() { return ECommSalesPromoService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}